import React from 'react'
// import PropTypes from 'prop-types'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons

import dashboardStyle from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle'

import UsersAllTable from '../Tables/UsersAllTable'

// Apollo thingy
import { graphql, Query } from 'react-apollo'
import { getUsers } from '../../queries/getUsersAllQuery'
import { jsonPP } from '../utility/utility'

// Questions here
// 1. don't see Loading/error when they are rendered
// 2. the data was split out with delay, was it an observable?

const UsersAll = () => (
  <Query query={getUsers} errorPolicy="all" fetchPolicy="network-only">
    {({ loading, error, data, refetch }) => {
      if (error) return <p>{jsonPP(error)}</p>
      if (loading) {
        return <p>Loading...</p>
      } else {
        // console.log('data is ready')
        // console.log(data)
        return <UsersAllTable users={data.users} refetch={refetch} />
      }
    }}
  </Query>
)

UsersAll.propTypes = {
  //classes: PropTypes.object.isRequired
}

export default graphql(getUsers)(withStyles(dashboardStyle)(UsersAll))
